import React from 'react'
import WithConfirmation from './WithConfirmation'
import SolidButton from './SolidButton'

export default function WithConfirmationButton({title, body, onConfirm, buttonType,...rest}) {

    if(!rest.color) {
        rest.color = 'warning'
    }

    function ButtonType({confirm}) {
        return buttonType === 'desktop' ?
            <div
                {...rest}
                onClick={confirm(onConfirm)}></div> :
            <SolidButton
                {...rest}
                onClick={confirm(onConfirm)}></SolidButton>
    }

    return (
        <WithConfirmation title={title} body={body}>
            {
                confirm => (
                    <ButtonType confirm={confirm}></ButtonType>
                )
            }
        </WithConfirmation>
    )

}
